module.exports = __webpack_public_path__ + "static/section-3-bbcdff723f08b1a6d3c6ebb7251650a2.jpg";